module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tone-talk"
  }, [_c('h2', {
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_vm._v("Hey, " + _vm._s(_vm.user.firstName) + ". Great to see you. "), _c('br'), _vm._v("Enjoy the Tone Talk!")]), _vm._v(" "), (!_vm.jwEventRef) ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-7"
  }, [_c('h3', {
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_vm._v("discussion")]), _vm._v(" "), (_vm.getUserSignature) ? _c('div', [_c('iframe', {
    attrs: {
      "width": "100%",
      "height": "650",
      "frameborder": "0",
      "scrolling": "no",
      "marginheight": "0",
      "marginwidth": "0",
      "allowtransparency": "true",
      "src": _vm.chatRollURL
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn-pink",
    on: {
      "click": _vm.leaveEvent
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out"
  }), _vm._v(" Leave")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-5"
  }, [_c('h3', {
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_vm._v("moderator")]), _vm._v(" "), _c('div', {
    staticClass: "moderatorContent"
  }, [_c('p', [_vm._v("\n                            " + _vm._s(_vm.getSelectedEvent[0].longDescription) + "\n                        ")]), _vm._v(" "), _c('h3', {
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_vm._v("attendees")]), _vm._v(" "), (_vm.eventUsersArray) ? _c('div', {
    staticClass: "slider responsive-slick-eventusers"
  }, [_c('div', {
    staticClass: "attendeesImg",
    attrs: {
      "*v-for": "userList in eventUsersArray"
    }
  }, [(_vm.userList[0]) ? _c('div', {
    staticClass: "userImage"
  }, [(_vm.userList[0].isAnonymous === '0') ? _c('div', [_c('img', {
    attrs: {
      "src": _vm.userList[0].picture,
      "alt": "USER-SHOE",
      "title": _vm.userList[0].firstName
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.userList[0].firstName))])]) : _c('div', [_c('img', {
    attrs: {
      "src": _vm.userList[0].picture,
      "alt": "USER-SHOE",
      "title": "Shoe-cognito"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Shoe-cognito")])])]) : _vm._e(), _vm._v(" "), (_vm.userList[1]) ? _c('div', {
    staticClass: "userImage"
  }, [(_vm.userList[1]) ? _c('div', {
    staticClass: "userImage"
  }, [(_vm.userList[1].isAnonymous === '0') ? _c('div', [_c('img', {
    attrs: {
      "src": _vm.userList[1].picture,
      "alt": "USER-SHOE",
      "title": _vm.userList[1].firstName
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.userList[1].firstName))])]) : _c('div', [_c('img', {
    attrs: {
      "src": _vm.userList[1].picture,
      "alt": "USER-SHOE",
      "title": "Shoe-cognito"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Shoe-cognito")])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.userList[2]) ? _c('div', {
    staticClass: "userImage"
  }, [(_vm.userList[2]) ? _c('div', {
    staticClass: "userImage"
  }, [(_vm.userList[2].isAnonymous === '0') ? _c('div', [_c('img', {
    attrs: {
      "src": _vm.userList[2].picture,
      "alt": "USER-SHOE",
      "title": _vm.userList[2].firstName
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.userList[2].firstName))])]) : _c('div', [_c('img', {
    attrs: {
      "src": _vm.userList[2].picture,
      "alt": "USER-SHOE",
      "title": "Shoe-cognito"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Shoe-cognito")])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.userList[3]) ? _c('div', {
    staticClass: "userImage"
  }, [(_vm.userList[3]) ? _c('div', {
    staticClass: "userImage"
  }, [(_vm.userList[3].isAnonymous === '0') ? _c('div', [_c('img', {
    attrs: {
      "src": _vm.userList[3].picture,
      "alt": "USER-SHOE",
      "title": _vm.userList[3].firstName
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.userList[3].firstName))])]) : _c('div', [_c('img', {
    attrs: {
      "src": _vm.userList[3].picture,
      "alt": "USER-SHOE",
      "title": "Shoe-cognito"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Shoe-cognito")])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.userList[4]) ? _c('div', {
    staticClass: "userImage"
  }, [(_vm.userList[4]) ? _c('div', {
    staticClass: "userImage"
  }, [(_vm.userList[4].isAnonymous === '0') ? _c('div', [_c('img', {
    attrs: {
      "src": _vm.userList[4].picture,
      "alt": "USER-SHOE",
      "title": _vm.userList[4].firstName
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.userList[4].firstName))])]) : _c('div', [_c('img', {
    attrs: {
      "src": _vm.userList[4].picture,
      "alt": "USER-SHOE",
      "title": "Shoe-cognito"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Shoe-cognito")])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.userList[5]) ? _c('div', {
    staticClass: "userImage"
  }, [(_vm.userList[5]) ? _c('div', {
    staticClass: "userImage"
  }, [(_vm.userList[5].isAnonymous === '0') ? _c('div', [_c('img', {
    attrs: {
      "src": _vm.userList[5].picture,
      "alt": "USER-SHOE",
      "title": _vm.userList[5].firstName
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.userList[5].firstName))])]) : _c('div', [_c('img', {
    attrs: {
      "src": _vm.userList[5].picture,
      "alt": "USER-SHOE",
      "title": "Shoe-cognito"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Shoe-cognito")])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.userList[6]) ? _c('div', {
    staticClass: "userImage"
  }, [(_vm.userList[6]) ? _c('div', {
    staticClass: "userImage"
  }, [(_vm.userList[6].isAnonymous === '0') ? _c('div', [_c('img', {
    attrs: {
      "src": _vm.userList[6].picture,
      "alt": "USER-SHOE",
      "title": _vm.userList[6].firstName
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.userList[6].firstName))])]) : _c('div', [_c('img', {
    attrs: {
      "src": _vm.userList[6].picture,
      "alt": "USER-SHOE",
      "title": "Shoe-cognito"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Shoe-cognito")])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.userList[7]) ? _c('div', {
    staticClass: "userImage"
  }, [(_vm.userList[7]) ? _c('div', {
    staticClass: "userImage"
  }, [(_vm.userList[7].isAnonymous === '0') ? _c('div', [_c('img', {
    attrs: {
      "src": _vm.userList[7].picture,
      "alt": "USER-SHOE",
      "title": _vm.userList[7].firstName
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.userList[7].firstName))])]) : _c('div', [_c('img', {
    attrs: {
      "src": _vm.userList[7].picture,
      "alt": "USER-SHOE",
      "title": "Shoe-cognito"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Shoe-cognito")])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.userList[8]) ? _c('div', {
    staticClass: "userImage"
  }, [(_vm.userList[8]) ? _c('div', {
    staticClass: "userImage"
  }, [(_vm.userList[8].isAnonymous === '0') ? _c('div', [_c('img', {
    attrs: {
      "src": _vm.userList[8].picture,
      "alt": "USER-SHOE",
      "title": _vm.userList[7].firstName
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.userList[8].firstName))])]) : _c('div', [_c('img', {
    attrs: {
      "src": _vm.userList[8].picture,
      "alt": "USER-SHOE",
      "title": "Shoe-cognito"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Shoe-cognito")])])]) : _vm._e()]) : _vm._e()])]) : _vm._e()])])])]) : _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "rowtight"
  }, [_c('div', {
    staticClass: "col-sm-7 innerpadding align:top"
  }, [_c('div', {
    staticClass: "embed-responsive embed-responsive-16by9"
  }, [_c('iframe', {
    staticClass: "embed-responsive-item",
    attrs: {
      "src": _vm.jwEventRef,
      "frameborder": "0",
      "scrolling": "auto",
      "allowfullscreen": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5 text-left"
  }, [(_vm.getUserSignature) ? _c('div', [_c('h4', {
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_vm._v("TONE Talks Coaching: " + _vm._s(_vm.getSelectedEvent[0].title))]), _vm._v(" "), _c('p', [_vm._v("Welcome! Join us for a discussion that will inspire and empower you to be the best version of yourself.")]), _vm._v(" "), (_vm.getShowCountFlag) ? _c('h6', [_vm._v("Total Participants: " + _vm._s(_vm.participantCount))]) : _vm._e(), _vm._v(" "), _c('iframe', {
    attrs: {
      "width": "100%",
      "height": "400px",
      "frameborder": "0",
      "scrolling": "no",
      "marginheight": "0",
      "marginwidth": "0",
      "allowtransparency": "true",
      "src": _vm.chatRollURL
    }
  })]) : _vm._e()])])])])
},staticRenderFns: []}


// WEBPACK FOOTER //
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-742bfb84"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"search":"pk_test_6pRNASCoBOKtIshFeQd4XMUh","replace":"pk_live_NgwNoBs3GAlrsSez07Zyh4Jc"}!./~/string-replace-loader?{"search":"https:/www1.dev-tonenetworks.com","replace":"https:/www.tonenetworks.com"}!./~/string-replace-loader?{"search":"https:/s3.amazonaws.com/tone-assets/app/navigation","replace":"https:/assets.tonenetworks.com/app/navigation"}!./~/string-replace-loader?{"search":"sandbox_2yn8x45w_k2v4j3d55x4gh6xz","replace":"production_6r7mxqgh_htw3nq9wp32w8h2x"}!./src/components/Talk.vue